// Loads the Contentsquare (formerly Hotjar) tag inside this document. The app runs in an
// iframe on the merchant's store, and a tag on the parent page cannot see into a
// cross-origin iframe — the tag has to run here, in the iframe itself.
// Every route is a full iframe load, so the tag's automatic first pageview is enough.
// Resolved at build time, so each bundle only contains its own env's tag.
// Stage and local runs (dev / local-fe-remote-*) get no tag, so they don't pollute recordings.
const getTagId = () => {
  if (process.env.REACT_APP_FE_ENV === 'PROD') return process.env.REACT_APP_CONTENTSQUARE_TAG_ID_PROD;
  if (process.env.REACT_APP_FE_ENV === 'TEST') return process.env.REACT_APP_CONTENTSQUARE_TAG_ID;
  return undefined;
};

export const initContentsquare = () => {
  const tagId = getTagId();
  if (!tagId) return;

  // `id` is the offer token that loads/accepts the offer — keep it out of collected URLs
  const query = new URLSearchParams(window.location.search);
  query.delete('id');
  const maskedQuery = query.toString();

  window._uxa = window._uxa || [];
  // The project has iframe tracking on, so inside an iframe the tag waits for a parent-page
  // tag to report through — the merchant's store has none. Autonomous mode makes it report itself.
  if (window.self !== window.top) window._uxa.push(['setIframeAutonomous']);
  window._uxa.push(['setPath', window.location.pathname]);
  window._uxa.push(['setQuery', maskedQuery ? `?${maskedQuery}` : '']);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://t.contentsquare.net/uxa/${tagId}.js`;
  document.head.appendChild(script);
};
